import React from 'react'
import { Typography } from 'antd';
import { Screen } from '../../components/UI/Screen.component';
import { Container } from '../../components/UI/Container.component';
import { ScreenHeader } from '../../components/UI/ScreenHeader.component';
import { Section } from '../../components/UI/Section.component';
import { AccessManagementTable } from '../../components/Dashboard/AccessManagement/AccessManagementTable.component';

const { Title } = Typography;

export const AccessScreen = () => {

    return(
        <>
            <Screen id="access-screen">
                <Container>
                    <ScreenHeader>
                        <Title>Access Management</Title>
                    </ScreenHeader>
                    <Section>
                        <AccessManagementTable />
                    </Section>
                </Container>
            </Screen>
        </>
    )
}